import { ActionType } from '../../constants/ActionTypes'
const CACHE_LIMIT = 100;

 export default function  seoRulesReducer  (state = {}, action = {}) {
    switch (action.type) {
        case ActionType.SET_SEO_CONTENT_PARAMS:
            const key = JSON.stringify(action.blockIds);

            return {
                ...state,
                content: {
                    ...state.content,
                    [key]: { ...action.contents, timestamp: action.timestamp }
                }
            };
        case ActionType.SET_SEO_PATHS_PARAMS:
            if (Object.keys(state.matchPaths).length >= CACHE_LIMIT){
                const oldestKey = Object.keys(state.matchPaths)[0];
                delete state.matchPaths[oldestKey];
            }
            return {
                ...state,
                matchPaths: {
                    ...state.matchPaths,
                    [action.path]:{ ids: action.blockIds, timestamp: action.timestamp }
                },
            };
        default:
            return state;
    }
}


